import type {
  InspectionTemplate,
  TemplateItem,
  TemplateSection,
} from 'inspection-types';

export type TemplateNode =
  | { type: 'section'; section: TemplateSection }
  | { type: 'item'; section: TemplateSection; item: TemplateItem };

function sortByOrder<T extends { order: number }>(nodes: T[]): T[] {
  return [...nodes].sort((a, b) => a.order - b.order);
}

export function sortSections(sections: TemplateSection[]): TemplateSection[] {
  return sortByOrder(sections);
}

export function sortItems(items: TemplateItem[]): TemplateItem[] {
  return sortByOrder(items);
}

export function findNode(
  template: InspectionTemplate,
  id: string
): TemplateNode | undefined {
  for (const section of template.sections) {
    if (section.id === id) {
      return { type: 'section', section };
    }

    const item = section.items.find(candidate => candidate.id === id);

    if (item) {
      return { type: 'item', section, item };
    }
  }

  return undefined;
}
